<template>
   <v-layout row wrap>
        <v-flex xs12 sm3 v-for="(vid, index) in videos" :key="index">
            <a data-fancybox="gallery" data-type="iframe" :href="vid.href">
                <div class="video-thumb">
                    <img :src="`/img/videos-thumbs/${vid.thumb}`" :alt="vid.name">
                    <p class="black--text small" v-html="vid.name"></p>                     
                </div>
            </a>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        props: ['videos']
    }
</script>

